<template>
  <h1>tmpl-summary</h1>
</template>

<script>
export default {
  name: 'TmplSummary'
}
</script>

<style scoped>

</style>
